import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { fetchDataFromApi } from "utils";
import {
  GRIEVANCE_ASSIGNEE_CONTROL,
  GRIEVANCE_ROLES_URL,
} from "configs/constants";
import eightAxios from "configs/axiosConfig";
import { useNotifyContext } from "@Components/Notify";

const Assignee = () => {
  const setNotify = useNotifyContext();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grievanceAssigneeControl, setGrievanceAssigneeControl] = useState({
    default_assignee: "",
    set_as_assignee: [],
    reminder_time: "",
  });

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  const initialValues = {
    default_assignee: grievanceAssigneeControl.default_assignee,
    set_as_assignee: grievanceAssigneeControl.set_as_assignee,
    reminder_time: grievanceAssigneeControl.reminder_time,
  };

  const validationSchema = Yup.object({
    default_assignee: Yup.string()
      .required("Default Assignee is required")
      .nullable(),
    set_as_assignee: Yup.array().min(1, "Set as Assignee is required"),
    reminder_time: Yup.number()
      .required("Reminder time is required")
      .test(
        "Is positive?",
        "ERROR: The number must be greater than 0!",
        (value) => value > 0
      ),
  });

  useEffect(() => {
    fetchDataFromApi(GRIEVANCE_ROLES_URL, setRoles, false);
    fetchDataFromApi(
      GRIEVANCE_ASSIGNEE_CONTROL,
      setGrievanceAssigneeControl,
      false
    );
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    eightAxios
      .post(GRIEVANCE_ASSIGNEE_CONTROL, values)
      .then((response) => {
        setGrievanceAssigneeControl(response.data);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        setLoading(false);
        setSubmitting(false);
      })
      .catch((error) => {
        console.log(error);
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        setLoading(false);
      });
  };

  const formFields = [
    { type: "title", title: "Default Assignee" },
    {
      type: "reactselect",
      label: "Default Assignee",
      name: "default_assignee",
      required: true,
      outerOptions: roles,
      gridSize: { lg: 4 },
    },

    { type: "title", title: "Assignee List" },
    {
      type: "reactselect",
      label: "Set As Assignee",
      name: "set_as_assignee",
      isMultiSelect: true,
      required: true,
      // showChips: true,
      outerOptions: roles,
      gridSize: { lg: 4 },
    },
    { type: "title", title: "Reminder" },
    {
      type: "input",
      label: "New Log Reminder (Today Date - Created Date (Days))",
      name: "reminder_time",
      required: true,
      gridSize: { lg: 4 },
    },
  ];
  const formButtons = ["save"];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <>
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        outerSubmitHandler={handleSubmit}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Assignee Control"
      />
    </>
  );
};

export default Assignee;
